import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  display: flex;
  border: 1px solid ${(props) => props.theme.$gray400};
  border-radius: 4px;

  .btn-input-send {
    background: ${(props) => props.theme.$info};
    color: ${(props) => props.theme.$white};
    border-radius: 0 4px 4px 0;
    &:disabled {
      cursor: default;
    }
  }

  .notes-input {
    width: calc(100% - 40px);
    padding: 8px;
    min-height: 44px;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 200px;
    scrollbar-color: ${(props) => props.theme.$info} ${(props) => props.theme.$white};
    scrollbar-width: thin;
    display: flex;
    align-items: center;
    user-select: text;

    &::before {
      content: 'Digite uma mensagem';
      color: ${(props) => props.theme.$gray600};
    }

    &.hide-content::before {
      content: '';
    }

    &[contentEditable='true']:focus {
      &::before {
        content: '';
      }
    }

    &[contentEditable='true']:hover {
      cursor: text;
    }

    &[contentEditable='false'] {
      opacity: 0.5;
    }
  }

  .btn-notes-audio span,
  .notes-audio-cancel,
  .notes-audio-submit {
    background: transparent;
    color: ${(props) => props.theme.$gray600};
    border-radius: 0px;
    padding: 2px;
    &:disabled {
      cursor: default;
    }
    &:hover {
      background: ${(props) => props.theme.$gray300};
      padding: 2px;
      border-radius: 4px;
    }
  }

  .notes-audio-equalizer-bars {
    display: flex;
    align-items: flex-end;
    gap: 3px;
    height: 20px;

    span {
      width: 3px;
      height: 6px;
      background: '#6c757d';
      border-radius: 2px;
      animation: equalizer 1s infinite ease-in-out;
    }

    span:nth-child(1) {
      animation-delay: 0s;
    }
    span:nth-child(2) {
      animation-delay: 0.15s;
    }
    span:nth-child(3) {
      animation-delay: 0.3s;
    }

    @keyframes equalizer {
      0% {
        height: 6px;
        opacity: 0.4;
      }
      50% {
        height: 18px;
        opacity: 1;
      }
      100% {
        height: 6px;
        opacity: 0.4;
      }
    }
  }
`;
